exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".carousel-control-next[data-v-9d79ce2e],.carousel-control-prev[data-v-9d79ce2e]{filter:invert(100%)}.additional-item-price-box[data-v-9d79ce2e]{display:block}.additional-item-price-box[data-v-9d79ce2e]:after{content:\"+\"}.additional-item-price-box[data-v-9d79ce2e]:last-child:after{content:\"\"}", ""]);

// exports
